export enum TravelType {
  FlightAndTaxi = 'FLIGHT_AND_TAXI',
  Flight = 'FLIGHT',
  Taxi = 'TAXI',
}
